import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import SingleCartItem from "./SingleCartItem";

function CartDesign(props) {
  const [amount, setAmount] = useState(0);
  const [noitem, setNoitem] = useState(false);

  useEffect(() => {
    let sum = 0;
    props.cart.forEach(
      (item) => (sum += item.discounted_price * item.quantity)
    );
    setAmount(sum);
    if (props.cart.length === 0) {
      setNoitem(true);
    } else {
      setNoitem(false);
    }
  }, [props.cart]);

  const handelRedirect = () => {
    if (props.token) {
      props.history.push("/order");
    } else {
      props.history.push("/login");
    }
  };

  return (
    <div className="my-3 container">
      <p className="h4 text-center"> YOUR CART</p>
      {noitem ? (
        <div>
          <p className="bg-danger text-center text-white py-3">
            You Cart Is Empty. <br />
            Please Purchase Any Product To Add It In Your Cart.
          </p>
        </div>
      ) : (
        <div className="row mx-auto">
          <div className="col-md-8 px-4">
            <p className="fw-bold h5 px-2 px-sm-4">Cart Items </p>
            <hr style={{ marginTop: "-5px", hieght: "2px" }} />
            {props.cart.map((item, i) => {
              return (
                <div key={item.id} className="row mb-3 align-items-center ">
                  <SingleCartItem item={item} />
                </div>
              );
            })}
            <hr style={{ marginTop: "-5px", hieght: "2px" }} />
          </div>
          <div
            className="col-md-4 p-4"
            style={{ borderLeft: "2px solid gray" }}
          >
            <div>
              <p>
                The Total Amount Is <span className="h6 fw-bold">{amount}</span>
              </p>
              <button
                type="button"
                className="btn btn-dark"
                onClick={handelRedirect}
              >
                Place Order
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    token: state.userDetails.token ? state.userDetails.token : null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    removeFromCart: (val) =>
      dispatch({ type: "REMOVE_FROM_CART", payload: val }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CartDesign);
